
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/[...slugs]",
      function () {
        return require("private-next-pages/m/[...slugs]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/[...slugs]"])
      });
    }
  